import * as actionTypes from "./actionTypes";

export const fetchPowerBIEmbedConfig = (keyword) => ({
  type: actionTypes.FETCH_POWERBI_EMBED_CONFIG,
  keyword
});

export const fetchPowerBIEmbedConfigSuccess = (keyword, payload) => ({
  type: actionTypes.FETCH_POWERBI_EMBED_CONFIG_SUCCESS,
  keyword,
  payload
});

export const fetchPowerBIEmbedConfigFailure = (error) => ({
  type: actionTypes.FETCH_POWERBI_EMBED_CONFIG_FAILURE,
  error
});

export const refreshPowerBIEmbedToken = () => ({
  type: actionTypes.REFRESH_POWERBI_EMBED_TOKEN
});

export const refreshPowerBIEmbedTokenSuccess = (token) => ({
  type: actionTypes.REFRESH_POWERBI_EMBED_TOKEN_SUCCESS,
  payload: token
});

export const refreshPowerBIEmbedTokenFailure = (error) => ({
  type: actionTypes.REFRESH_POWERBI_EMBED_TOKEN_FAILURE,
  error
});

export const setCurrentDashboard = (keyword) => ({
  type: actionTypes.SET_CURRENT_DASHBOARD,
  keyword
});

export const resetDashboardCache = (keyword = null) => ({
  type: actionTypes.RESET_DASHBOARD_CACHE,
  keyword // null to reset all, specific keyword to reset just that one
});
